import { parseMetaString } from "../../utils/common";
import { parseMetaTagsBundle } from "../plpApi/constants";
import { HOME_CMS_BATCH_PATHS } from "./constant";

/**
 * Maps homepage CMS batch gateway response for the home route.
 * Pre-parses SEO fields (same `parsed` shape as PLP via `parseMetaTagsBundle`).
 * `parsed.metaParsed` reflects `homeBannerRes.headAnalytics` for script fallbacks.
 *
 * @param {Object} batchResponse - Map keyed by CMS paths
 * @param {Object} params
 * @param {boolean} params.isMobile
 * @returns {Object} Mapped bundle with `homeBannerRes` and `parsed`
 */
export const mapHomeBatchApiResponse = (batchResponse, { isMobile }) => {
  const homeBannerRes = batchResponse?.[HOME_CMS_BATCH_PATHS.HOMEPAGE]?.content || {};

  const parsed = parseMetaTagsBundle(homeBannerRes);
  parsed.metaParsed = homeBannerRes?.headAnalytics ? parseMetaString(homeBannerRes.headAnalytics) : null;

  return {
    homeBannerRes,
    appRedirectBannerResponse:
      isMobile && batchResponse?.[HOME_CMS_BATCH_PATHS.APP_REDIRECT_BANNER]?.content
        ? batchResponse[HOME_CMS_BATCH_PATHS.APP_REDIRECT_BANNER].content
        : {},
    freeBannerData: !isMobile ? batchResponse?.[HOME_CMS_BATCH_PATHS.FREE_DELIVERY_BANNER]?.content || null : null,
    parsed,
  };
};
